var validator;
var Forget = function() {

    var _handleForgetForm = function(e) {

        validator = $("#formForgot").validate({
            ignore: null,
            rules: {
                email: {
                    required: true,
                    email: true,
                },
            },
            errorElement: "div",
            errorClass : 'fv-help-block',
            wrapper: 'div',
            highlight: function(element) {
                $(element).closest('.form-control').addClass('is-invalid');
            },
            unhighlight: function(element) {
                $(element).closest(".form-control").removeClass("is-invalid");
            },
            errorPlacement: function(error, element) {
                error.addClass('fv-plugins-message-container');
                if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent()); // radio/checkbox?
                } else if (element.hasClass('select2')) {
                    error.insertAfter(element.next('span')); // select2
                } else if (element.attr("type") == "radio") {
                    error.insertAfter(element.closest('div.radio-inline'));
                } else if (element.attr("name") == "content") {
                    error.insertAfter("div#cke_content");
                } else {
                    error.insertAfter(element); // default
                }
            },
        });
    }

    return {
        init: function() {
            _handleForgetForm();
        }
    };
}();

jQuery(function() {
    Forget.init();
});